<template>
    <div>
        <b-button
            variant="primary"
            @click.stop="abrirModal()"
            :disabled="contratacoes ? contratacoes.length == 0 : false"
            ><i class="fa fa-user"></i> Designar Gestor</b-button
        >
        <b-modal v-model="mostrarModal" @show="preencherModal()" size="lg">
            <div slot="modal-title">
                Designação de Gestor
            </div>
            <b-row v-if="!contratacoes">
                <b-col sm="12">
                    Gestor da contratação:
                    <strong>{{ contratacao.gestor }}</strong
                    ><br />
                    <span v-if="contratacao.gestorDesignado"
                        >Gestor designado:
                        <strong
                            >{{ contratacao.gestorDesignado }}
                            <span v-if="contratacao.fimDesignacaoGestor">
                                até
                                {{
                                    $moment(
                                        contratacao.fimDesignacaoGestor
                                    ).format('DD/MM/YYYY')
                                }}</span
                            ></strong
                        ></span
                    >
                </b-col>
            </b-row>
            <b-row v-if="contratacoes">
                <b-col sm="12">
                    Contratações:<br />
                    <span
                        v-for="(contratacao, index) in contratacoes"
                        :key="contratacao.codContratacao"
                    >
                        <span v-if="index > 0"> | </span>
                        <strong>{{ contratacao.codContratacao }}</strong>
                    </span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h5 class="heading-1 mt-4">
                        <span>Novo gestor designado</span>
                    </h5>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="8">
                    <b-form-group>
                        <label>Selecione o novo gestor designado</label>
                        <b-form-select
                            :options="colaboradoresDisponiveis"
                            v-model="colaboradorSelecionado"
                            text-field="colaborador"
                            value-field="matricula"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label>Designado até</label>
                        <date-picker
                            v-model="fimDesignacao"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    class="ml-2"
                    variant="primary"
                    :disabled="!colaboradorSelecionado"
                    @click.stop="confirmarSalvar()"
                    >Salvar</b-button
                >
                <b-button
                    class="ml-2"
                    variant="danger"
                    v-if="mostrarBtnExcluir"
                    @click.stop="confirmarExcluir()"
                    >Excluir <span v-if="!contratacoes">gestor designado</span
                    ><span v-if="contratacoes"
                        >gestores designados</span
                    ></b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        contratacoesServicos: {
            type: Object,
            required: true,
            default: () => ({})
        },

        contratacao: {
            type: Object,
            default: () => ({})
        },

        contratacoes: {
            type: Array
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            colaboradorSelecionado: null,
            colaboradoresDisponiveis: [],
            fimDesignacao: null
        }
    },

    methods: {
        fecharModal() {
            this.colaboradorSelecionado = null
            this.colaboradoresDisponiveis = []
            this.mostrarModal = false
        },

        abrirModal() {
            this.mostrarModal = true
        },

        preencherModal() {
            this.obterColaboradoresDisponiveis()
        },

        obterColaboradoresDisponiveis() {
            this.$store.dispatch('addRequest')
            let promisse
            if (this.contratacoes) {
                promisse = this.contratacoesServicos.obterColaboradoresDisponiveis()
            } else {
                promisse = this.contratacoesServicos.obterColaboradoresDisponiveis(
                    this.$route.params.contratacaoId
                )
            }
            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.colaboradoresDisponiveis = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter colaboradores disponíveis',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarSalvar() {
            let colaborador = this.colaboradoresDisponiveis.find(
                p => p.matricula == this.colaboradorSelecionado
            ).colaborador
            let mensagem = ''
            if (this.contratacoes) {
                mensagem = `Confirma a designação do gestor ${colaborador}
                paras as contratações selecionadas?`
            } else {
                mensagem = `Confirma a designação do gestor ${colaborador}
                para contratação ${this.contratacao.codContratacao}?`
            }
            this.$swal({
                title: 'Designação de gestor',
                html: mensagem,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            let designacaoGestorDto = {}
            if (this.contratacoes) {
                designacaoGestorDto = {
                    contratacoes: this.contratacoes.map(c => {
                        return c.codContratacao
                    }),
                    codGestor: this.colaboradorSelecionado,
                    fimDesignacao: this.fimDesignacao
                        ? this.$moment(this.fimDesignacao, 'DD/MM/YYYY').format(
                              'YYYY-MM-DD'
                          )
                        : null
                }
            } else {
                designacaoGestorDto = {
                    codContratacao: this.contratacao.codContratacao,
                    codGestor: this.colaboradorSelecionado,
                    fimDesignacao: this.fimDesignacao
                        ? this.$moment(this.fimDesignacao, 'DD/MM/YYYY').format(
                              'YYYY-MM-DD'
                          )
                        : null
                }
            }

            this.$store.dispatch('addRequest')

            this.contratacoesServicos
                .designarGestor(designacaoGestorDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                `Designaç${
                                    this.contratacoes ? 'ões' : 'ão'
                                } realizada${
                                    this.contratacoes ? 's' : ''
                                } com sucesso`,
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterAtualizacao')
                            this.fecharModal()
                        } else {
                            this.$toast.error(
                                `Erro ao designar gestor${
                                    this.contratacoes ? 'es' : ''
                                }`,
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        confirmarExcluir() {
            let mensagem = ''
            if (this.contratacoes) {
                mensagem = `Confirma a exclusão do gestor designado das contratações selecionadas?`
            } else {
                mensagem = `Confirma a exclusão do gestor designado ${this.contratacao.gestorDesignado}
                da contratação ${this.contratacao.codContratacao}?`
            }
            this.$swal({
                title: 'Exclusão do gestor designado',
                html: mensagem,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            let exclusaoGestorDesignadoDto = {}
            if (this.contratacoes) {
                exclusaoGestorDesignadoDto = {
                    contratacoes: this.contratacoes.map(c => {
                        return c.codContratacao
                    })
                }
            } else {
                exclusaoGestorDesignadoDto = {
                    codContratacao: this.contratacao.codContratacao
                }
            }

            this.$store.dispatch('addRequest')
            this.contratacoesServicos
                .excluirGestorDesignado(exclusaoGestorDesignadoDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                `Designaç${
                                    this.contratacoes ? 'ões' : 'ão'
                                } excluída${
                                    this.contratacoes ? 's' : ''
                                } com sucesso`,
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterAtualizacao')
                            this.fecharModal()
                        } else {
                            this.$toast.error(
                                `Erro ao excluir designação do${
                                    this.contratacoes ? 's' : ''
                                } gestor${this.contratacoes ? 'es' : ''}`,
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {},

    computed: {
        mostrarBtnExcluir() {
            return (
                this.contratacao.gestorDesignado ||
                (this.contratacoes &&
                    this.contratacoes.some(c => c.gestorDesignado))
            )
        }
    }
}
</script>
